<template>
    <router-link :to="{ name: 'UserForm', params: { id: local_fileanswer.userform.id }}">
        <div
            v-if="local_fileanswer"
            class="fileanswerPreviewCard"
            :class="{'inset': inset}"
        >
            <v-layout
                row
                wrap
            >
                <div
                    v-if="!inset"
                    style="background:rgba(0,0,0,0.05);border-radius:25px;padding:4px;margin: 10px;aspect-ratio: 1/1;width:32.5px;height:32.5px;"
                >
                    <v-icon>
                        {{ 'mdi-file-check' }}
                    </v-icon>
                </div>
                <div>
                    <b>{{ local_fileanswer.userform.name }}</b>
                    <br/><br/>
                    <span>{{ local_fileanswer.file }}</span>
                </div>
            </v-layout>
        </div>
    </router-link>
</template>

<script>
import api from '@/api'

export default {
    name: 'FileAnswerPreview',
    props: ['fileAnswer', 'id', 'inset', 'userform_id'],
    data() {
        return {
            local_fileanswer: null,
            searching: false,
        }
    },
    created () {
        if (this.fileAnswer){
            this.local_fileanswer = JSON.parse(JSON.stringify(this.fileAnswer))
        } else {
            if(this.id){
                alert("Not implemented!")
            }
        }
    }
}
</script>

<style scoped>
.fileanswerPreviewCard {
    background: rgba(0,0,0,0.05);
    padding: 5px;
    border-radius:5px;
    cursor:pointer;  
}

.fileanswerPreviewCard:hover {
    background: rgba(0,0,0,0.1);
}

.inset {
    background: unset;
    padding: unset !important;
}

a {
    text-decoration: none;
    color: black;
}
</style>